import { messages as errorMessages } from './failure/index.tsx';
import { messages as successMessages } from './success/index.tsx';

export const successFlag = () => ({
	type: 'success',
	...successMessages,
	messageId: 'navigation-shortcuts.add-repository-modal.flags.flag.success',
	messageType: 'transactional',
});

export const errorFlag = () => ({
	type: 'error',
	...errorMessages,
	messageId: 'navigation-shortcuts.add-repository-modal.flags.flag.error',
	messageType: 'transactional',
});
